<div class="row">
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Primary DI</th>
                    <th class="col-sm-8">Issuing Agency </th>
                  </tr>
                  <tr>
                    <td><label controlName="udiDI"></label></td>
                    <td><label controlName="agency"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table formArrayName="deviceDescriptionForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>Device Description</th>
                  </tr>
                  <ng-container *ngIf="deviceDescriptionForm.controls.length; else emptyTemplate1fields">
                  <tr formGroupName="{{i}}" *ngFor="let name of deviceDescriptionForm.controls; let i = index">
                    <td colspan="2"> <label controlName="value"></label>
                    </td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>Product Name/Generic Name</th>
                  </tr>
                  <tr>
                    <td> <label
                        controlName="productGenericNames"></label>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table formArrayName="tradeNamesForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>Brand or Trade Name(s)</th>
                  </tr>
                  <ng-container *ngIf="tradeNamesForm.controls.length; else emptyTemplate1fields">
                  <tr formGroupName="{{i}}" *ngFor="let name of tradeNamesForm.controls; let i = index">
                    <td colspan="2">
                      <label controlName="value"></label>
                    </td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>

          </tr>
          <tr>
            <td colspan="2" class="no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-2">Quantity of Device</th>
                    <th class="col-sm-4">Unit of Use DI</th>
                    <th class="col-sm-6">URL for Additional Information</th>
                  </tr>
                  <tr>
                    <td><label controlName="quantityOfDevice"></label>
                    </td>
                    <td><label controlName="unitOfUseDi"></label></td>
                    <td> <label
                        controlName="urlForAdditionalInfo"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>


          <tr>
            <td colspan="2" class="no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Version or Model </th>
                    <th class="col-sm-6">Catalog or Reference Number</th>
                  </tr>
                  <tr>
                    <td>
                      <label controlName="versionOrModel"></label>
                    </td>
                    <td><label
                        controlName="referenceOrCatalogNumber"></label></td>
                  </tr>
                </tbody>
              </table>

            </td>

          </tr>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-4">NMPA Classification Code</th>
                    <th class="col-sm-8">NMPA Original Classification Code</th>
                  </tr>
                  <tr>
                    <td><label
                        controlName="classificationCode"></label></td>
                    <td><label
                        controlName="originalClassificationCode"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table formArrayName="diDataCarrierTypesForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>DI Data Carrier Type</th>
                  </tr>
                  <ng-container *ngIf="diDataCarrierTypesForm?.controls?.length; else emptyTemplate1fields">
                  <tr formGroupName="{{i}}" *ngFor="let code of diDataCarrierTypesForm.controls; let i = index">
                    <td><label controlName="value"></label></td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>


          <tr>
            <td colspan="2" class="no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-2">Has Direct Marking DI?</th>
                    <th class="col-sm-4">Is Direct Marking DI same as Primary DI?</th>
                    <th class="col-sm-6">Direct Marking DI</th>
                  </tr>
                  <tr>
                    <td><label controlName="hasDirectMarking"></label>
                    </td>
                    <td><label
                        controlName="isDirectMarkingDiSameAsPrimaryDi"></label></td>
                    <td><label controlName="directMarkingDI"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Production Identification Controlled By:</th>
                    <th class="col-sm-6"></th>
                  </tr>
                  <tr>
                    <td>Expiration Date?</td>
                    <td><label
                        controlName="isExpirationDate"></label></td>
                  </tr>
                  <tr>
                    <td>Manufacturing Date?</td>
                    <td><label
                        controlName="isManufacturingDate"></label></td>
                  </tr>
                  <tr>
                    <td>Lot or Batch Number?</td>
                    <td><label
                        controlName="isLotOrBatchNumber"></label></td>
                  </tr>
                  <tr>
                    <td>Serial Number?</td>
                    <td><label
                        controlName="isSerialNumber"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>

          </tr>

        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1fields>
  <tr>
    <td><label></label></td>
  </tr>
</ng-template>
